import * as React from "react";
import { useEffect } from "react";
import { Box, Card, CardContent, Typography, Grid } from "@mui/material";
import SettingsOutlinedIcon from '@mui/icons-material/SettingsOutlined';
import Title from "../../Components/Title";
import { useNavigate } from "react-router-dom";

export default function Configuration() {
  const navigate = useNavigate();

  // ===== ESC KEY HANDLER - GO TO DASHBOARD =====
  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      if (event.key === "Escape") {
        event.preventDefault();
        event.stopPropagation();
        navigate("/settings");
      }
    };
    window.addEventListener("keydown", handleKeyDown, true);
    return () => window.removeEventListener("keydown", handleKeyDown, true);
  }, [navigate]);

  return (
    <>
      <Title pageTitle="Configuration" />
      
      <Grid container sx={{ padding: "16px 24px 0px 20px" }}>
        <Grid item>
          <h4>Configuration</h4>
        </Grid>
      </Grid>

      <Grid container spacing={2} style={{ padding: "8px 16px 16px 16px" }}>
        <Grid item xs={12} md={6} xl={6}>
          <Box className="setting-page-mainCard">
            <Card 
              className="setting-page-card"
              onClick={() => navigate("/preferences")}
              sx={{ cursor: 'pointer' }}
            >
              <CardContent>
                <Grid className="setting-page-card-box">
                  <Grid>
                    <span className="menu-icon-span">
                      <SettingsOutlinedIcon className="menu-icon" color="primary" />
                    </span>
                  </Grid>
                  <Grid pl={2}>
                    <Typography variant="h3" className="setting-page-card-amount card-discription-h3">
                      <span className="card-discription-h3-span">Preferences</span>
                    </Typography>
                    <Typography variant="h4" className="setting-page-card-title">
                      Manage your app preferences and display settings.
                    </Typography>
                  </Grid>
                </Grid>
              </CardContent>
            </Card>
          </Box>
        </Grid>
      </Grid>
    </>
  );
}